import React, { useState } from "react";

import { NavLink } from "react-router-dom";

const Menu = (props) => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  return (
    <>
      <label className="sidebar-label pd-x-15 mg-t-20">Navigation</label>
      <div className="br-sideleft-menu">
        <NavLink to="/" className="br-menu-link">
          <i className="br-menu-link" />
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-ios-home-outline tx-22" />
            <span className="menu-item-label">Home</span>
          </div>
        </NavLink>
        <NavLink to="#" className="br-menu-link">
          <div className="br-menu-item">
            <i className="menu-item-icon icon ion-images tx-24"></i>
            <span className="menu-item-label">Media</span>
            <i className="menu-item-arrow fa fa-angle-down"></i>
          </div>
        </NavLink>
        <ul className="br-menu-sub nav flex-column">
          {/* <li className="nav-item"><NavLink to="/media/upload" className="nav-link">Upload</NavLink></li>
                <li className="nav-item"><NavLink to="/media" className="nav-link">My Media</NavLink></li> */}
          <li className="nav-item">
            <NavLink to="/s3media/s3upload" className="nav-link">
              Upload
            </NavLink>
          </li>
		  {user.mailid?.endsWith("@tv9.com") ? (
				<>
				  <li className="nav-item">
					<NavLink to="/s3media/s3upload_tv9/" className="nav-link">
					  Upload TV9
					</NavLink>
				  </li>
				</>
				): (
			  <></>
			)}
          <li className="nav-item">
            <NavLink to="/s3media" className="nav-link">
              My Media
            </NavLink>
          </li>
        </ul>
        {user.role === "English" || user.role === "EnglishEditor" ? (
          <>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-chatbubble-working tx-24"></i>
                <span className="menu-item-label">Story</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/storyposts/add-post" className="nav-link">
                  Add Story
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/storyposts" className="nav-link">
                  View Story
                </NavLink>
              </li>
            </ul>
          </>
        ) : (
          <>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-ios-lightbulb-outline tx-24"></i>
                <span className="menu-item-label">Ideas</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/ideas" className="nav-link">
                  My Ideas
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/ideas/add-idea" className="nav-link">
                  New Idea
                </NavLink>
              </li>
            </ul>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-chatbubble-working tx-24"></i>
                <span className="menu-item-label">Posts</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/posts/add-post" className="nav-link">
                  New Post
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/posts" className="nav-link">
                  My Posts
                </NavLink>
              </li>
            </ul>

            
          </>
        )}

        {user.role === "Editor" ? (
          <>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-document tx-24"></i>
                <span className="menu-item-label">Assignments</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/assignments/add-assignment" className="nav-link">
                  New Assignment
                </NavLink>
              </li>
              {/* <li className="nav-item"><NavLink to="/assignments" className="nav-link">My Assignments</NavLink></li> */}
            </ul>
          </>
        ) : (
          ""
        )}

        {user.role === "Editor" || user.role === "Admin" ? (
          <>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-chatbubble-working tx-24"></i>
                <span className="menu-item-label">Manage Users</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/admin/add-user" className="nav-link">
                  Add User
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/users" className="nav-link">
                  Users
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/user-report" className="nav-link">
                  Contribution
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/user-report" className="nav-link">
                  User Report
                </NavLink>
              </li>
            </ul>

            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-chatbubble-working tx-24"></i>
                <span className="menu-item-label">Masters</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
              <li className="nav-item">
                <NavLink to="/masters/add-city" className="nav-link">
                  Add City
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/masters/cities" className="nav-link">
                  Cities
                </NavLink>
              </li>
            </ul>
          </>
        ) : (
          ""
        )}
        {user.role === "Admin" ? (
          <>
            <NavLink to="#" className="br-menu-link">
              <div className="br-menu-item">
                <i className="menu-item-icon icon ion-chatbubble-working tx-24"></i>
                <span className="menu-item-label">Admin</span>
                <i className="menu-item-arrow fa fa-angle-down"></i>
              </div>
            </NavLink>
            <ul className="br-menu-sub nav flex-column">
				
              <li className="nav-item">
                <NavLink to="/admin/roles/" className="nav-link">
                  All Roles
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/roles/add-role" className="nav-link">
                  Add Role
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/permissions/" className="nav-link">
                  All Permissions
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/admin/permissions/add-permission"
                  className="nav-link"
                >
                  Add Permission
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/admin/rolespermissions" className="nav-link">
                  All Role Permission Mapping
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/admin/rolespermissions/add-rolepermission"
                  className="nav-link"
                >
                  Role Permission Mapping
                </NavLink>
              </li>
            </ul>
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};
export default Menu;
